import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationItem } from '@fc-core/navbar/navigation/navigation-item';

@Component({
  selector: 'fc-navigation-popover',
  standalone: true,
  template: `
    @if (context()) {
      <div class="bg-primary-1000 rounded-xl shadow-xl p-8 min-w-[240px] ml-8">
        <div class="text-sm text-secondary-400 px-8 py-4 mb-4">
          {{ context().title }}
        </div>
        <div class="flex flex-col gap-2  text-secondary-300">
          @for (child of context().children; track $index) {
            <a
              class="w-full flex items-center cursor-pointer hover:bg-primary-900 rounded-lg
               py-8 px-12 text-base hover:text-secondary-50 transition-all duration-150 text-left text-nowrap"
              [routerLink]="child.link"
              routerLinkActive="bg-primary-900 text-secondary-50"
              (click)="click.emit()"
            >
              {{ child.name }}
            </a>
          }
        </div>
      </div>
    }
  `,
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationPopoverComponent {
  context = input<{ title?: string; children?: NavigationItem[] }>();
  click = output();
}
